import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt',
  },

  theme: {
    themes: {
      light: {
        primary: '#083452',
        secondary: '#18324f',
        tertiary: '#1E1E1E',
        accent: '#A17640',
      },
    },
  },
});
